import { useMutation } from '@tanstack/react-query';
import { useClientStore } from '@/client/stores/client';
import { withErrorHandling } from '@/client/utils/errors';
import { TestPayload, TestResult } from '@/client/types/ai-management';
import { unwrapEnvelope } from './overview.query';

const TEST = '/llm-admin/test';

// Runs a one-off completion server-side. No API key is ever sent from the
// browser — the proxy injects credentials on the server.
const useRunTestFn = () => {
  const request = useClientStore((s) => s.request);
  return withErrorHandling(async (payload: TestPayload): Promise<TestResult> => {
    const raw = await request<any>(TEST, 'POST', payload, { timeout: 60_000 });
    return unwrapEnvelope<TestResult>(raw);
  }, 'Test call failed');
};

export const useRunTestMutation = () => {
  const runFn = useRunTestFn();
  return useMutation({
    mutationFn: (payload: TestPayload) => runFn(payload),
  });
};
